import React from 'react';
import { Dialog, Fade } from '@mui/material';
import { ConfirmationModalProps } from '../../../types';
import styles from './ConfirmationModal.module.scss'; 

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    open,
    onClose,
    onConfirm,
    title,
    description,
    confirmText = 'Confirmar',
    cancelText = 'Cancelar',
    confirmColor = 'error',
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            TransitionComponent={Fade}
            transitionDuration={200}
            PaperProps={{
                className: styles['modal']
            }}
            slotProps={{
                backdrop: {
                    className: styles['modal-backdrop']
                }
            }}
        >
            <h2 id="confirmation-modal-title" className={styles['modal-title']}>
                {title}
            </h2>
            <p id="confirmation-modal-copy" className={styles['modal-copy']}>
                {description}
            </p>
            <div className={styles['modal-actions']}>
                <button
                    className={`${styles['btn']} ${styles['btn-secondary']}`}
                    id="confirmation-modal-cancel"
                    type="button"
                    onClick={onClose}
                >
                    {cancelText}
                </button>
                <button
                    className={`${styles['btn']} ${confirmColor === 'error' ? styles['btn-destructive'] : styles['btn-primary']}`}
                    id="confirmation-modal-confirm"
                    type="button"
                    onClick={() => {
                        onConfirm();
                        onClose();
                    }}
                >
                    {confirmText}
                </button>
            </div>
        </Dialog>
    );
};

export default ConfirmationModal;